import React from 'react';
import { Button, Container } from 'react-bootstrap';
import { faChevronRight, faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ContactSignUp from '../../Components/ContactSignUp';



function Sustainability(props) {

   return (
      <div className='container-fluid'>
         <div className='row  mb-5 pb-0 pb-lg-5 ' >
            <div className='col'>
               <div className="bgSustainability">
                  <img className='img-fluid w-100' src="../../../server-build/Images/HeaderImage.png" />
                  <div className='sustainabilityHeading text-white'>
                     <h2 className='pb-0 pb-lg-3 pt-3 pt-lg-0 mb-0'>Growing more, growing better</h2>
                     <p className='fw-semibold lh-base d-none d-lg-block'>At Superplum, sustainability is not just a commitment; it's a way of ensuring that<br />
                        our fruits reach your table with the least impact on our precious planet</p>
                  </div>
               </div>
            </div>

         </div>

         <div className="row">
            <div className="col">
               <Container>
                  <div className="row justify-content-center ">
                     <div className="col">
                        <div className='row justify-content-evenly align-items-center mb-5 pb-0 pb-lg-5'>
                        <div className='col-12 col-lg-5 d-lg-none'>
                              <div >
                                 <h2 className="mb-3">Reduced <br className='d-none d-lg-block' />Wastage</h2>
                                 <p>Our tech-enabled transportation<br className='d-none d-lg-block'/>
                                    system not only ensures the <br className='d-none d-lg-block'/>
                                    freshness of our fruits but also <br className='d-none d-lg-block'/>
                                    significantly reduces overall <br className='d-none d-lg-block'/>
                                    wastage by over 50%, <br className='d-none d-lg-block'/>
                                    contributing to a more <br className='d-none d-lg-block' />
                                    sustainable supply chain</p>
                              </div>
                           </div>
                           <div className=' col-12 col-lg-7 '>
                              <img className="img-fluid" src="../../../server-build/Images/ReducedWastage.png" />
                           </div>
                           <div className='col-12 col-lg-5 d-none d-lg-block'>
                              <div >
                                 <h2 className="mb-3">Reduced <br className='d-none d-lg-block' />Wastage</h2>
                                 <p>Our tech-enabled transportation<br className='d-none d-lg-block'/>
                                    system not only ensures the <br className='d-none d-lg-block'/>
                                    freshness of our fruits but also <br className='d-none d-lg-block'/>
                                    significantly reduces overall <br className='d-none d-lg-block'/>
                                    wastage by over 50%, <br className='d-none d-lg-block'/>
                                    contributing to a more <br className='d-none d-lg-block' />
                                    sustainable supply chain</p>
                              </div>
                           </div>
                        </div>


                        <div className='row justify-content-center align-items-center  mb-5 pb-0 pb-lg-5'>
                           <div className='col-12 col-lg-5'>
                              <div>
                                 <h2 className="mb-3">Eco-friendly <br className='d-none d-lg-block'/>Packaging</h2>
                                 <p>Each variety of fruit is stored,<br className='d-none d-lg-block'/>
                                    transported and sold in unique<br className='d-none d-lg-block'/>
                                    packaging that not only protects <br className='d-none d-lg-block'/>
                                    the fruit from damage, but also <br className='d-none d-lg-block'/>
                                    doesn t harm the environment.</p>
                              </div>
                           </div>
                           <div className='col-12 col-lg-7'>
                              <img src="../../../server-build/Images/Eco-friendlypacks.png" className="img-fluid" />
                           </div>
                        </div>


                        <div className='row justify-content-evenly align-items-center mb-5 pb-0 pb-lg-5'>
                        <div className='col-12 col-lg-5 d-lg-none'>
                              <div >
                                 <h2 className="mb-3">Reduced Carbon<br className='d-none d-lg-block'/> Emissions</h2>
                                 <p>Our commitment to transparency<br className='d-none d-lg-block'/>
                                    extends to revealing the total<br className='d-none d-lg-block'/>
                                    carbon emissions data for each<br className='d-none d-lg-block' />
                                    fruit pack, empowering<br className='d-none d-lg-block'/>
                                    consumers to make<br className='d-none d-lg-block'/>
                                    environmentally conscious<br className='d-none d-lg-block' />
                                    choices.</p>
                                    <Button className="blackButton rounded-pill mb-3 mb-lg-0 fw-bold d-none d-lg-block">Know How</Button>
                              </div>
                           </div>
                           <div className=' col-12 col-lg-7 '>
                              <img src="../../../server-build/Images/ReducedCarbonEmissions.png" className="img-fluid" />
                           </div>
                           <div className='col-12 col-lg-5 d-none d-lg-block'>
                              <div >
                                 <h2 className="mb-3">Reduced Carbon<br className='d-none d-lg-block'/> Emissions</h2>
                                 <p>Our commitment to transparency<br className='d-none d-lg-block'/>
                                    extends to revealing the total<br className='d-none d-lg-block'/>
                                    carbon emissions data for each<br className='d-none d-lg-block' />
                                    fruit pack, empowering<br className='d-none d-lg-block'/>
                                    consumers to make<br className='d-none d-lg-block'/>
                                    environmentally conscious<br className='d-none d-lg-block' />
                                    choices.</p>
                                    <Button className="blackButton rounded-pill mb-3 mb-lg-0 fw-bold d-none d-lg-block">Know How</Button>
                              </div>
                           </div>
                        </div>


                        <div className='row justify-content-center align-items-center  mb-5 pb-0 pb-lg-5'>
                         
                           <div className='col-12 col-lg-5'>
                              <div>
                                 <h2 className="mb-3">Farmer-friendly <br className='d-none d-lg-block' /> Practices</h2>

                                 <p>Our farmers are at the very heart <br className='d-none d-lg-block' />
                                    of our operations. That s why <br className='d-none d-lg-block'/>
                                    we ve partnered with BAYER to <br className='d-none d-lg-block'/>
                                    arm them with the knowledge <br className='d-none d-lg-block' />
                                    and tools to grow sustainably.</p>
                                    <Button className="blackButton rounded-pill mb-3 mb-lg-0 fw-bold d-none d-lg-block">Read More</Button>
                              </div>
                           </div>
                           <div className='col-12 col-lg-7'>
                              <img src="../../../server-build/Images/FarmerFriendlyPractices.png" className="img-fluid" />
                           </div>
                        </div>


                     </div>
                  </div>
               </Container>
            </div>
         </div>

         <div className='row mb-5'>
            <div className='col'>
               <Container>
                  <div className='row'>
                     <div className='col '>
                        <p className='text-decoration-underline'><FontAwesomeIcon icon={faChevronLeft} />&nbsp; <span className='fw-semibold'>Our Technology</span> </p>
                     </div>
                     <div className=' col-auto'>
                        <p className='text-decoration-underline'><span className='fw-semibold'>Partner with us</span> &nbsp; <FontAwesomeIcon icon={faChevronRight} /></p>
                     </div>
                  </div>
               </Container>
            </div>
         </div>
   
         <div className='row mb-5 pb-0 pb-lg-5'>
            <div className='col'>
               <ContactSignUp />
            </div>
         </div>

      </div>
   );


}

export default Sustainability; 